module.exports = __webpack_public_path__ + "fonts/iconfont.8a0a272d.ttf";